module.exports = __webpack_public_path__ + "media/15.9e55be9f.mp3";